module.exports = __webpack_public_path__ + "ui-static/img/cameras-no-items_light.236d1110.svg";